import { isOpenWorldJournalPositiveInteger, isOpenWorldJournalRecord, isOpenWorldJournalUuid } from '@/lib/openWorlds/journalPersistence'
import type { CreateOpenWorldPlaythroughResponse } from '@/lib/openWorlds/persistence'

export interface OpenWorldForkOrigin {
  playthroughId: string
  messageId: string | null
  messageRole: 'opening' | 'player' | 'storyteller'
  turnNumber: number
}

export interface ForkOpenWorldPlaythroughRequest {
  id: string
  receiptId: string
  playthroughId: string
  expectedRevision: number
  expectedHeadId: string | null
  messageId: string | null
  messageRole: OpenWorldForkOrigin['messageRole']
  /** Absent keeps the existing setup, including for legacy pending receipts. */
  duplicateSetup?: { id: string; expectedRevision: number }
}

export type ForkOpenWorldPlaythroughResponse = CreateOpenWorldPlaythroughResponse

export function validOpenWorldFork(request: unknown): request is ForkOpenWorldPlaythroughRequest {
  if (!isOpenWorldJournalRecord(request)) return false
  const keys = ['id', 'receiptId', 'playthroughId', 'expectedRevision', 'expectedHeadId', 'messageId', 'messageRole']
  if (Object.hasOwn(request, 'duplicateSetup')) {
    const setup = request.duplicateSetup
    if (!isOpenWorldJournalRecord(setup) || Object.keys(setup).length !== 2 ||
      !isOpenWorldJournalUuid(setup.id) || setup.id === request.id || setup.id === request.playthroughId ||
      !isOpenWorldJournalPositiveInteger(setup.expectedRevision) || setup.expectedRevision > 2_147_483_647) return false
    keys.push('duplicateSetup')
  }
  return Object.keys(request).length === keys.length && keys.every(key => Object.hasOwn(request, key)) &&
    isOpenWorldJournalUuid(request.id) && isOpenWorldJournalUuid(request.receiptId) &&
    isOpenWorldJournalUuid(request.playthroughId) && request.id !== request.playthroughId &&
    isOpenWorldJournalPositiveInteger(request.expectedRevision) && request.expectedRevision <= 2_147_483_647 &&
    (request.expectedHeadId === null || isOpenWorldJournalUuid(request.expectedHeadId)) &&
    (request.messageRole === 'opening' ? request.messageId === null :
      ['player', 'storyteller'].includes(request.messageRole as string) && isOpenWorldJournalUuid(request.messageId))
}
